import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SdTitleComponent } from '../../title/title.component';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { CoreModalService } from '../../modals/core-modal/core-modal.service';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { ILink } from '../../../_interfaces/link.interface';
import { SdDropdownComponent } from '../../dropdowns/dropdown/dropdown.component';
import { SdLinkComponent } from '../../links/link/link.component';
import { SdListComponent } from '../../lists/list/list.component';

@Component({
  selector: 'sd-dropdown-help',
  templateUrl: './dropdown-help.component.html',
  standalone: true,
  imports: [
    SdDropdownComponent,
    SdTitleComponent,
    SdListComponent,
    SdLinkComponent,
    TranslateModule
  ]
})
export class SdDropdownHelpComponent {
  constructor(private readonly coreModalService: CoreModalService) {}
  iconSize = IconSizeEnum;

  @Input()
  brand: BrandsEnum;

  @Input()
  links: ILink[];

  closeDropdown() {
    this.coreModalService.closeAllModal();
  }
}
